/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Keys_Table_Rows_Per_PageInputs */



/**
* | output |
* | --- |
* | "Rows per page:" |
*
* @param {Api_Keys_Table_Rows_Per_PageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const api_keys_table_rows_per_page = /** @type {((inputs?: Api_Keys_Table_Rows_Per_PageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Keys_Table_Rows_Per_PageInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeilen pro Seite:")
	return /** @type {LocalizedString} */ ("Rows per page:")
});